<div class="h-100 w-100 d-flex flex-column flex-grow-1 overflow-auto" [attr.dir]="isRTL ? 'rtl' : 'ltr'">
    <div class="position-absolute w-100 d-flex justify-content-end">
        <button type="button" mat-icon-button aria-label="Close dialog" (click)="closeDialog()"
            class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Scrollable content container -->
    <div class="d-flex flex-column flex-grow-1 overflow-auto px-4 py-3 gap-3 w-100" 
         [class.zx-settings-area-inner-rtl]="!isRTL"
         [class.text-white]="isDarkMode"
         style="padding-top: 60px;">
        <!-- [printing properties] title: -->
        <h6 class="d-flex mb-0 zx-text-medium zx-text-sm-big fw-bold text-green zx-px-10 px-2" style="padding-top: 1rem; margin-bottom: -10px;">
            {{'about-us.how-it-works' | translate}}
        </h6>
        <span class="zx-text-small px-2" *ngIf="!isPhPrintMode">
            {{'choose-product.explain.3Dprint' | translate}}
        </span>
        <span class="zx-text-small px-2" *ngIf="isPhPrintMode">
            {{'ph-print-explain.intro' | translate}}
        </span>
        
        <!-- NEW CONTENT: How it works -->
        <div class="d-flex flex-column gap-2" [class.text-white]="isDarkMode">
            <!-- Step 1: Technology selection (3D flow only) -->
            <div *ngIf="!isPhPrintMode" [class.bg-white]="!isDarkMode"
                class="d-flex flex-column zx-shadow-85-light w-100 py-1 px-3 gap-1 px-md-3 rounded-2">
                <b class="zx-text-small zx-text-sm-medium pt-1"
                    [class.text-green]="!isDarkMode">
                    <span>1. </span>
                    <span>{{ 'tree-d-print.explain.1.title' | translate }}</span>
                </b>
                <p class="zx-text-small m-0 pb-1">
                    {{ 'tree-d-print.explain.1.content' | translate }}
                    <span class="d-inline-flex align-items-center gap-1 c-pointer"
                          [matTooltip]="'collect.click-more-info' | translate"
                          [matTooltipPosition]="'below'"
                          [matTooltipShowDelay]="300"
                          [matTooltipDisabled]="!isScreenWide || isTechnologyOpen('MJF')"
                          (click)="onTechnologyClick('MJF')">
                        <span class="fw-bold" 
                              [class.text-green]="!isTechnologyOpen('MJF')"
                              [class.zx-text-pink]="isTechnologyOpen('MJF')">MJF</span>
                        <img src="/assets/images/i-explain-icon.svg" class="i-explain-icon svg zx-text-tiny">
                    </span>
                    <span>, </span>
                    <span class="d-inline-flex align-items-center gap-1 c-pointer"
                          [matTooltip]="'collect.click-more-info' | translate"
                          [matTooltipPosition]="'below'"
                          [matTooltipShowDelay]="300"
                          [matTooltipDisabled]="!isScreenWide || isTechnologyOpen('FDM')"
                          (click)="onTechnologyClick('FDM')">
                        <span class="fw-bold"
                              [class.text-green]="!isTechnologyOpen('FDM')"
                              [class.zx-text-pink]="isTechnologyOpen('FDM')">FDM</span>
                        <img src="/assets/images/i-explain-icon.svg" class="i-explain-icon svg zx-text-tiny">
                    </span>
                    <span *ngIf="isRTL"> או </span>
                    <span *ngIf="!isRTL"> or </span>
                    <span class="d-inline-flex align-items-center gap-1 c-pointer"
                          [matTooltip]="'collect.click-more-info' | translate"
                          [matTooltipPosition]="'below'"
                          [matTooltipShowDelay]="300"
                          [matTooltipDisabled]="!isScreenWide || isTechnologyOpen('SLA')"
                          (click)="onTechnologyClick('SLA')">
                        <span class="fw-bold"
                              [class.text-green]="!isTechnologyOpen('SLA')"
                              [class.zx-text-pink]="isTechnologyOpen('SLA')">SLA</span>
                        <img src="/assets/images/i-explain-icon.svg" class="i-explain-icon svg zx-text-tiny">
                    </span>
                </p>
                <!-- Expandable technology explanations -->
                <div *ngIf="selectedTechnology" 
                     [@slideDownUp]
                     class="technology-explanation rounded-3 shadow-85 d-flex align-items-center gap-1 gap-sm-2 gap-md-3 p-2 position-relative"
                     [class.bg-white]="!isDarkMode"
                     [class.step-item-dark]="isDarkMode">
                    <!-- Desktop icon -->
                    <div class="d-none d-sm-flex rounded-2 zx-big-icon-size mx-1 zx-border-gray-v-light p-2">
                        <img [src]="'assets/images/products/' + selectedTechnology + '.svg'"
                             [alt]="selectedTechnology + ' Logo'" class="w-100 h-100 rounded-2">
                    </div>
                    <div class="d-flex flex-column h-100 justify-content-between py-2 flex-grow-1 px-2">
                        <div class="d-flex align-items-center gap-2 zx-tech-title-row">
                            <!-- Mobile icon in circle -->
                            <div [class.bg-light-darkmode]="isDarkMode"
                                class="d-flex d-sm-none rounded-circle zx-medium-small-icon-size zx-border-gray-v-light p-2">
                                <img [src]="'assets/images/products/' + selectedTechnology + '.svg'"
                                     [alt]="selectedTechnology + ' Logo'" class="w-100 h-100">
                            </div>
                            <div class="d-flex flex-column">
                                <h6 class="fw-bold mb-0 mb-sm-1 zx-text-big"
                                    [ngClass]="isRTL ? 'text-end' : 'text-start'">
                                    {{ "choose-product.naming." + selectedTechnology | translate }}
                                </h6>
                                <span
                                    class="fw-normal text-body-secondary zx-text-small"
                                    [ngClass]="isRTL ? 'text-end' : 'text-start'"
                                    [attr.dir]="parentheticalExpansionDir()">
                                    ({{ 'choose-product.detailed-description.expansion.' + selectedTechnology | translate }})
                                </span>
                            </div>
                        </div>
                        <span class="zx-text-small opacity-75"
                              [ngClass]="isRTL ? 'text-end' : 'text-start'">
                            {{ "choose-product.detailed-description." + selectedTechnology | translate }}
                        </span>
                        <span class="text-green zx-text-small"
                              [ngClass]="isRTL ? 'text-end' : 'text-start'">
                            {{ "choose-product.suitable-for." + selectedTechnology | translate }}
                        </span>
                        <button mat-raised-button color="primary" 
                                class="mt-2 rounded-pill zx-text-white position-relative zx-upload-tech-btn"
                                [disabled]="isLoading"
                                (click)="onUploadFileForTechnology(selectedTechnology)">
                            <div [class.opacity-50]="isLoading" class="d-flex align-items-center justify-content-center">
                                <b>{{ 'tree-d-print.upload-file-for-technology' | translate: {technology: ('choose-product.naming.' + selectedTechnology | translate)} }}</b>
                            </div>
                            <div *ngIf="isLoading" class="w-100 h-100 d-flex position-absolute top-0 start-0 align-items-center justify-content-center">
                                <mat-spinner class="zx-small-icon-size"></mat-spinner>
                            </div>
                        </button>
                    </div>
                    <button type="button" 
                            mat-icon-button 
                            aria-label="Close explanation"
                            (click)="closeTechnologyExplanation()"
                            class="close-technology-btn d-flex align-items-center justify-content-center">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </div>
            <!-- Step 1: Product selection (PH non‑3D flow) -->
            <div *ngIf="isPhPrintMode" [class.bg-white]="!isDarkMode"
                class="d-flex flex-column zx-shadow-85-light w-100 py-1 px-3 gap-1 px-md-3 rounded-2">
                <b class="zx-text-small zx-text-sm-medium pt-1"
                    [class.text-green]="!isDarkMode">
                    <span>1. </span>
                    <span>{{ 'ph-print-explain.step1.title' | translate }}</span>
                </b>
                <p class="zx-text-small m-0 pb-1">
                    {{ 'ph-print-explain.step1.content' | translate }}
                </p>
            </div>
            <!-- Steps 2–6 (3D flow, includes quote step 4) -->
            <ng-container *ngIf="!isPhPrintMode">
                <div *ngFor="let j of [2, 3, 4, 5, 6]" [class.bg-white]="!isDarkMode"
                    class="d-flex flex-column zx-shadow-85-light w-100 py-1 px-3 gap-1 px-md-3 rounded-2">
                    <b class="zx-text-small zx-text-sm-medium pt-1"
                        [class.text-green]="!isDarkMode">
                        <span>{{ j + ". "}}</span>
                        <span>{{ 'tree-d-print.explain.' + j + '.title' | translate }}</span>
                    </b>
                    <p class="zx-text-small m-0 pb-1">
                        {{'tree-d-print.explain.' + j + '.content' | translate}}
                    </p>
                </div>
            </ng-container>
            <!-- Steps 2–5 (PH flow: no quote step; former 5→4, 6→5) -->
            <ng-container *ngIf="isPhPrintMode">
                <div *ngFor="let s of phPrintFlowSteps" [class.bg-white]="!isDarkMode"
                    class="d-flex flex-column zx-shadow-85-light w-100 py-1 px-3 gap-1 px-md-3 rounded-2">
                    <b class="zx-text-small zx-text-sm-medium pt-1"
                        [class.text-green]="!isDarkMode">
                        <span>{{ s.stepLabel }}. </span>
                        <span>{{ s.titleKey | translate }}</span>
                    </b>
                    <p class="zx-text-small m-0 pb-1">
                        {{ s.contentKey | translate }}
                    </p>
                </div>
            </ng-container>
        </div>
        <!-- // NEW CONTENT: How it works -->

        <ng-container *ngIf="!isPhPrintMode">
        <b class="pt-3 pt-md-4 px-2">
            {{ "tree-d-print.title.2" | translate }}
        </b>
        <div class="d-flex flex-column gap-2">
            <!-- Step 1: Choose a file from file bank -->
            <div [class.bg-white]="!isDarkMode"
                class="d-flex flex-column zx-shadow-85-light w-100 py-1 px-3 gap-1 px-md-3 rounded-2">
                <b class="zx-text-small zx-text-sm-medium pt-1"
                    [class.text-green]="!isDarkMode">
                    <span>
                        1. 
                    </span>
                    <span>
                        {{ 'tree-d-print.exp.bank-1-title' | translate}}
                    </span>
                </b>
                <p class="zx-text-small m-0 pb-1">
                    {{'tree-d-print.exp.bank-1-content' | translate}}
                </p>
                <!-- Recommended sites links -->
                <div class="d-flex flex-wrap gap-2 pt-2 pb-1" [class.text-white]="isDarkMode">
                    <ng-container *ngFor="let j of [1, 2, 3, 4, 5]">
                        <button *ngIf="linksBanck3DPrint[j-1]?.url" mat-stroked-button color="primary"
                            class="rounded-pill"
                            (click)="openBankLink(linksBanck3DPrint[j-1].url)">
                            <span class="d-flex align-items-center gap-1 gap-sm-2">
                                <span class="zx-text-tiny">
                                    {{ 'tree-d-print.link.' + j + '-title' | translate }}
                                </span>
                                <mat-icon class="m-0 p-1 zx-text-big c-pointer h-100 pt-1">
                                    open_in_new
                                </mat-icon>
                            </span>
                        </button>
                    </ng-container>
                </div>
                <!-- // Recommended sites links -->
            </div>
            <!-- Step 2: Upload the file -->
            <div [class.bg-white]="!isDarkMode"
                class="d-flex flex-column zx-shadow-85-light w-100 py-1 px-3 gap-1 px-md-3 rounded-2">
                <b class="zx-text-small zx-text-sm-medium pt-1"
                    [class.text-green]="!isDarkMode">
                    <span>
                        2. 
                    </span>
                    <span>
                        {{ 'tree-d-print.exp.bank-2-title' | translate}}
                    </span>
                </b>
                <p class="zx-text-small m-0 pb-1">
                    {{'tree-d-print.exp.bank-2-content' | translate}}
                </p>
            </div>
        </div>
        </ng-container>
        <!-- // EXPLAIN 3D PRINTING PROCESS -->
    </div>

    <!-- Fixed buttons at bottom -->
    <div class="d-flex flex-column w-100 p-3 gap-2" style="flex-shrink: 0; border-top: 1px solid rgba(0,0,0,0.12);" [class.border-top-white]="isDarkMode">
        <button mat-raised-button color="primary" class="w-100 rounded-pill zx-text-white" (click)="closeDialog()">
            <b>{{ 'error-content-ok-btn' | translate }}</b>
        </button>
    </div>
</div>

